var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeftActiveArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 10,
    viewBox: "0 0 11 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.8531 4.60672C10.8997 4.65832 10.9366 4.71962 10.9618 4.7871C10.987 4.85459 11 4.92694 11 5C11 5.07306 10.987 5.14541 10.9618 5.2129C10.9366 5.28038 10.8997 5.34168 10.8531 5.39328L6.85344 9.8371C6.75956 9.9414 6.63224 10 6.49947 10C6.36671 10 6.23938 9.9414 6.1455 9.8371C6.05162 9.7328 5.99888 9.59133 5.99888 9.44382C5.99888 9.29631 6.05162 9.15485 6.1455 9.05054L9.29224 5.55548L0.49996 5.55548C0.367362 5.55548 0.240195 5.49695 0.146435 5.39278C0.0526741 5.28861 -2.24997e-07 5.14732 -2.18557e-07 5C-2.12117e-07 4.85268 0.0526741 4.71139 0.146435 4.60722C0.240195 4.50305 0.367362 4.44452 0.49996 4.44452L9.29224 4.44452L6.1455 0.949457C6.09902 0.897811 6.06214 0.836499 6.03699 0.76902C6.01183 0.701541 5.99888 0.629218 5.99888 0.556179C5.99888 0.483141 6.01183 0.410817 6.03699 0.343339C6.06214 0.27586 6.09902 0.214547 6.1455 0.162901C6.19199 0.111255 6.24717 0.0702871 6.3079 0.0423365C6.36864 0.0143858 6.43373 -2.00686e-07 6.49947 -1.96724e-07C6.56521 -1.92762e-07 6.63031 0.0143859 6.69104 0.0423365C6.75177 0.0702871 6.80696 0.111255 6.85344 0.162901L10.8531 4.60672Z",
    fill: "#F453C4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftActiveArrow);
export default __webpack_public_path__ + "static/media/left-active-arrow.7ea651562f54be8f534c39e67e1d1dc4.svg";
export { ForwardRef as ReactComponent };